// client/src/pages/BrecAppPage.js — public page /app: "Get the BREC app". The one link
// the office hands out to staff, agents and clients (no login needed to read it).
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BrecAppGuide from '../components/shared/BrecAppGuide';

const BrecAppPage = () => {
    // Is the Android file published? HEAD on the download — no login, no data.
    const [apk, setApk] = useState(null);
    useEffect(() => {
        let live = true;
        fetch('/app/android', { method: 'HEAD', cache: 'no-store' })
            .then((r) => { if (live) setApk(r.ok); })
            .catch(() => { if (live) setApk(null); });
        return () => { live = false; };
    }, []);
    return (
        <div className="max-w-5xl mx-auto px-4 py-8 sm:py-12">
            <div className="flex items-center gap-4 mb-6">
                <img src="/icons/icon-96.png" alt="" className="w-14 h-14 rounded-xl" />
                <div>
                    <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">The BREC app</h1>
                    <p className="text-slate-600">The whole portal on your phone, tablet or computer — free, and always up to date.</p>
                </div>
            </div>
            <BrecAppGuide apkAvailable={apk} />
            <p className="mt-6 text-sm text-slate-600">
                Staff and agents: <Link to="/portal" className="text-indigo-700 underline">sign in to the portal</Link>.{' '}
                Clients: <Link to="/client-portal/login" className="text-indigo-700 underline">client portal sign-in</Link>.
            </p>
        </div>
    );
};

export default BrecAppPage;
